import React, { useState } from "react";
import { Modal, Table } from "react-bootstrap";
import { Button } from "@atoms";

import { IProps } from "@atoms/SimplTooltipModal/types";
import { getPriceWithFraction } from "@utils";

const MgsShippingChargeModal: React.FC<IProps> = (
  {
    show, onHide
  }: IProps) => {
  const prices = JSON.parse(sessionStorage.getItem('mgsShippingPrices'));
  return (
    <Modal show={show} onHide={onHide} size={"lg"}>
      <Modal.Body>
        <p>Per Maccaron policy, we charge shipping fee based on the total weight of the items ordered. Please refer to the table below for exact shipping fee. </p>
        <Table responsive>
          <tbody>
            {
              prices?.map((price, i) => {
                if (price.node.startOrderWeight.value == 0) {
                  return (
                    <tr key={i}>
                      <td>below {price.node.stopOrderWeight.value}{price.node.stopOrderWeight.unit}</td>
                      <td>{getPriceWithFraction(price.node.price.amount, true, true)}</td>
                    </tr>
                  );
                } else {
                  return (
                    <tr key={i}>
                      <td>more than {price.node.startOrderWeight.value}{price.node.startOrderWeight.unit} below {price.node.stopOrderWeight.value}{price.node.stopOrderWeight.unit}</td>
                      <td>{getPriceWithFraction(price.node.price.amount, true, true)}</td>
                    </tr>
                  );
                }

              })
            }
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer style={{ justifyContent: "center" }}>
        <Button onClick={onHide} color="primary">close</Button>
      </Modal.Footer>
    </Modal>
  )
};

export { MgsShippingChargeModal }